/**
 * Video Masthead Widget JS Handler Class.
 */
class VideoMastheadWidgetHandler extends elementorModules.frontend.handlers.Base {
	/**
	 * Get Default Settings
	 *
	 * Returns an object of default settings.
	 */
	getDefaultSettings() {
		return {
			selectors: {
				imageOverlay: '.video-masthead__poster',
				videoWrapper: '.video-masthead__embed',
				pauseButton: '.video-masthead__controls',
			},
		};
	}

	/**
	 * Get Default Elements
	 *
	 * Returns an object of default jquery elements.
	 */
	getDefaultElements() {
		const selectors = this.getSettings('selectors');
		return {
			$imageOverlay: this.$element.find(selectors.imageOverlay),
			$videoWrapper: this.$element.find(selectors.videoWrapper),
			$pauseButton: this.$element.find(selectors.pauseButton),
		};
	}

	/**
	 * Bind Events
	 *
	 * Runs after the widget is loaded to bind events to the element.
	 */
	bindEvents() {
		const $pauseButton = this.elements.$pauseButton;
		const classes = {
			paused: 'js-video-is-paused',
			playing: 'js-video-is-playing',
		};

		$pauseButton.on('click', () => {
			if ($pauseButton.hasClass(classes.playing)) {
				this.player.pause();
				$pauseButton.removeClass(classes.playing);
				$pauseButton.addClass(classes.paused);
			} else {
				this.player.play();
				$pauseButton.removeClass(classes.paused);
				$pauseButton.addClass(classes.playing);
			}
		});
	}

	/**
	 * On Init
	 *
	 * Runs when the widget is loaded and initialized in the frontend.
	 */
	onInit() {
		super.onInit();
		this.player = null;

		let apiProvider;
		const $wrapper = this.elements.$videoWrapper;
		const $poster = this.elements.$imageOverlay;
		const url = $wrapper.attr('data-media-url');

		switch ($wrapper.attr('data-provider')) {
			case 'hosted':
				this.player = $wrapper.find('video').get(0);
				break;

			case 'vimeo':
				apiProvider = elementorFrontend.utils.vimeo;
				apiProvider.onApiReady((Vimeo) => {
					this.player = new Vimeo.Player($wrapper[0], {
						autoplay: true,
						background: false,
						byline: false,
						controls: false,
						loop: true,
						muted: true,
						portrait: false,
						title: false,
						url: url,
					});

					this.player.ready().then(() => {
						this.player.on('play', () => {
							$poster.fadeOut(1000);
						});
					});
				});
				break;
		}
	}
}

/**
 * Register JS Handler for the Video Masthead Widget
 */
elementorFrontend.elements.$window.on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler('video-masthead', VideoMastheadWidgetHandler);
});
